import { PromoterTypes } from '@mm/state/model/PromoterModel';
import { useCallback } from 'react';
import { NUMERIC_OPTIONS } from '../../../../editor/features/beta/modules/Automations/AutomationHome/TemplateIndex/Templates/Builders/Components/TemplateShared';
import { useCreateCampaignHandlers } from '../../../../editor/features/beta/modules/Campaigns/use-create-campaign-handlers';

export const useCreateGetemails = () => {
  const { createByKind } = useCreateCampaignHandlers();
  const createCreateGetemailsCampaign = useCallback(
    async (botId: number) => {
      await createByKind(
        'automation',
        'email_sold_automation',
        {
          active: true,
          inputTriggers: [{ kind: PromoterTypes.GETEMAILS }],
          unicornEmailQuantity: NUMERIC_OPTIONS[0].id,
          unicornOnly: true,
        },
        botId,
      );
    },
    [createByKind],
  );

  return { createCreateGetemailsCampaign };
};
